import { gql } from "@apollo/client"

// export const GROUP_SESSION = gql`
//   query GroupSession($staff_id: ID, $idTemplate: ID!) {
//     groupSession: blocksSavedByIdTemplate(
//       staff_id: $staff_id
//       idTemplate: $idTemplate
//       groupByIdStamp: true
//     ) {
//       data
//     }
//   }
// `

// export const GROUP_SESSION_PARTICIPANT = gql`
//   query GroupSession(
//     $organization_id: ID
//     $idTemplate: ID!
//   ) {
//     groupSession: blocksSavedByIdTemplate(
//       organization_id: $organization_id
//       idTemplate: $idTemplate
//       groupByIdStamp: true
//     ) {
//       data
//     }
//   }
// `

// export const GROUP_SESSION_STAFF = gql`
//   query GroupSessionGetUser($staff_id: ID!) {
//     user(staff_id: $staff_id) {
//       staff_id
//       staff_alias
//       staff_name_first
//       staff_name_last
//       staff_email_address
//       staff_phone_number
//       staff_phone_telerecovery
//     }
//   }
// `

export const GROUP_SESSION_PARTICIPANT = gql`
query EngagementsParticipant(
  $organization_id: ID!
  $idTemplate: ID!
  $idBlocks: [ID]
  $staff_id: ID
) {
  groupSession: getAllTemplateSaved(
    organization_id: $organization_id
    idTemplate: $idTemplate
    idBlocks: $idBlocks
    staff_id: $staff_id
  ) {
    data
  }
}
`
